<div [key]="key" obgAccordionHeader>
	<span class="title" *ngIf="titleText" [innerHTML]="titleText | translate"></span>
	<span
		[ngClass]="{
			'obg-accordion-header-component-icon': true,
			'ico-remove-circle': expanded,
			'ico-add-circle': !expanded,
		}"
	></span>
</div>
